<div class="dropdown-wrapper">
  <div class="dropdown-button-wrapper">
    <ui-button
      class="progress-dropdown-button"
      #dropdownMenuButton
      [ngSwitch]="goalAttainmentType"
      [uiDropdownMenu]="progressMenu"
      (uiVisibleChange)="onDropdownMenuOpen($event)"
      (keydown)="openDropdownMenu($event)"
      ui-button
      uiTrigger="click"
      ui-dropdown
      uiType="text">
      <span id="dropdown-button-label" *ngSwitchCase="'average_kr'">{{ "key_results" | localize }} </span>
      <span id="dropdown-button-label" *ngSwitchCase="'average_children'">{{ "child_objectives_cap" | localize }} </span>
      <span id="dropdown-button-label" *ngSwitchCase="'average_children_kr'">{{ "key_results_and_child_objectives" | localize }} </span>
    </ui-button>
    <i class="fs-12px down-icon" [style.float]="'right'" ui-icon uiTheme="outline" uiType="arrow-down-small"></i>
    <ui-dropdown-menu class="dropdown-actions-menu" #progressMenu="uiDropdownMenu" [style.z-index]="10000" feature-toggle-enabled="okr-contributors" data-test-id="dropdown-actions-menu">
      <ul ui-menu>
        <li
          class="dropdown-list-item"
          #firstListItem
          [attr.aria-label]="'key_results' | localize"
          [attr.aria-live]="'polite'"
          [attr.aria-atomic]="true"
          [attr.tabindex]="0"
          (keydown)="handleKeydown($event, 'average_kr')"
          (click)="onProgressCalculateTypeChange('average_kr')"
          ui-menu-item>
          <span class="dropdown-menu-button" data-test-id="objective-modal-progress-option-key-results">
            {{ "key_results" | localize }}
          </span>
        </li>
        <li
          class="dropdown-list-item"
          [attr.aria-label]="'child_objectives_cap' | localize"
          [attr.aria-live]="'polite'"
          [attr.aria-atomic]="true"
          [attr.tabindex]="0"
          (keydown)="handleKeydown($event, 'average_children')"
          (click)="onProgressCalculateTypeChange('average_children')"
          ui-menu-item>
          <span class="dropdown-menu-button" data-test-id="objective-modal-progress-option-child-objectives">
            {{ "child_objectives_cap" | localize }}
          </span>
        </li>
        <li
          class="dropdown-list-item"
          [attr.aria-label]="'key_results_and_child_objectives' | localize"
          [attr.aria-live]="'polite'"
          [attr.aria-atomic]="true"
          [attr.tabindex]="0"
          (keydown)="handleKeydown($event, 'average_children_kr')"
          (click)="onProgressCalculateTypeChange('average_children_kr')"
          ui-menu-item>
          <span class="dropdown-menu-button" data-test-id="objective-modal-progress-option-krs-and-child-objectives">
            {{ "key_results_and_child_objectives" | localize }}
          </span>
        </li>
      </ul>
    </ui-dropdown-menu>
  </div>
</div>
